import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  IndentRequestStatusUpdate,
  SpecificIndentList
} from "../../Repository/Api";
import { errorMsg, successMsg } from "../Toastify";

const IndentSpecificView = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token


  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getSpecificlist();
  },[]);

  const [specificIndent, setSpecificIndent] = useState({
    product_details: [
      {
        product_id: "",
        already_acknowledged_quantity: "",
      },
    ],
  });

  const [tempChanges, setTempChanges] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);

  const getSpecificlist = async () => {
    const response = await SpecificIndentList(id, token);
    if (response && response.statusCode === 200) {
      setSpecificIndent(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  const handleChange = (newValue, key, field, index, maxQty) => {
    const numericValue = parseFloat(newValue);

    if (isNaN(numericValue)) {
      setErrorMessages((prevErrors) => {
        const updatedErrors = [...prevErrors];
        updatedErrors[index] = "Invalid input: Only valid number.";
        return updatedErrors;
      });
      return;
    }

    setErrorMessages((prevErrors) => {
      const updatedErrors = [...prevErrors];
      updatedErrors[index] = null;
      return updatedErrors;
    });

    const tempChange = {
      index,
      field,
      value: numericValue,
      error:
        numericValue !== parseInt(maxQty, 10)
          ? "Quantity should be the same as New Issued Quantity"
          : null,
    };

    setTempChanges((prevChanges) => {
      const updatedChanges = [...prevChanges];
      updatedChanges[index] = tempChange;
      return updatedChanges;
    });
  };

  const removeIdFromInstances = (data) => {
    const updatedData = {};
    for (const key in data) {
      if (Array.isArray(data[key])) {
        updatedData[key] = data[key].map((item) => {
          const {
            status,
            quantity,
            hold_quantity,
            approved_quantity,
            rejected_quantity,
            issued_quantity_status,
            product_issued_log,
            product_name,
            remaining_quantity_in_store,
            ...rest
          } = item;
          return rest;
        });
      } else {
        updatedData[key] = data[key];
      }
    }

    return updatedData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const mainKey = "product_details";

    const Payload = {
      ...specificIndent,
    };

    const clonedSpecificIndent = { ...specificIndent };

    delete Payload.created_at;
    delete Payload.created_by;
    delete Payload.department;
    delete Payload.department_id;
    delete Payload.director_comment;
    delete Payload.director_status;
    delete Payload.employee_name;
    delete Payload.hod_comment;
    delete Payload.hod_status;
    delete Payload.indent_id;
    delete Payload.indent_number;
    delete Payload.is_deleted;
    delete Payload.requested_date;
    delete Payload.status;
    delete Payload.updated_at;
    delete Payload.updated_by;

    const modifiedData = tempChanges
      .filter((change) => change && change.index !== undefined)
      .map((change) => {
        const { index, field, value } = change;

        if (
          clonedSpecificIndent[mainKey] &&
          clonedSpecificIndent[mainKey][index] &&
          clonedSpecificIndent[mainKey][index][field] !== value
        ) {
          clonedSpecificIndent[mainKey][index][field] = value;

          return {
            product_id: clonedSpecificIndent[mainKey][index].product_id,
            [field]: value,
          };
        }

        return null;
      })
      .filter(Boolean);

    const pay = {
      id: id,
      [mainKey]: modifiedData,
    };

    const modifiedPayload = removeIdFromInstances(pay);

    const response = await IndentRequestStatusUpdate(modifiedPayload, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      getSpecificlist();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      errorMsg(response.message);
    }
  };

  const buttonstatus = specificIndent?.product_details?.some(
    (product) =>
      product?.already_acknowledged_quantity !== product?.issued_quantity
  );

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6 p-0">
              <h6 className="headertext">{first_name + ' ' + last_name}</h6>
              </div>
              <div className="col-lg-6 p-0">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/Indent/IndentForm");
                    }}
                  >
                    Apply For New Indent
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="col-lg-11">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Back To Indent List
                </h6>
                <div className="mt-5">
                  <h5 className="labeltitle centertext">
                    Indent Form Specific View
                  </h5>
                  <div className="row mt-5">
                    <div className="col-lg-4 col-md-5">
                      <h6>1. Indentor Name</h6>
                    </div>
                    <div className="col-lg-1 p-0">:</div>
                    <div className="col-lg-5">
                      <h6>{specificIndent?.employee_name}</h6>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-lg-4 col-md-5">
                      <h6>2. Department</h6>
                    </div>
                    <div className="col-lg-1 p-0">:</div>
                    <div className="col-lg-5">
                      <h6>{specificIndent?.department}</h6>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-lg-4 col-md-5">
                      <h6>3. Indent Number</h6>
                    </div>
                    <div className="col-lg-1 p-0">:</div>
                    <div className="col-lg-5">
                      <h6>
                        {specificIndent?.indent_number
                          ? specificIndent?.indent_number
                          : "NA"}
                      </h6>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-lg-4 col-md-5">
                      <h6>4. Indent Raised Date</h6>
                    </div>
                    <div className="col-lg-1 p-0">:</div>
                    <div className="col-lg-5">
                      <h6>
                        {moment(specificIndent?.requested_date).format(
                          "DD-MM-yyyy"
                        )}
                      </h6>
                    </div>
                  </div>
                  {specificIndent?.hod_comment ? (
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>5. HOD Comment</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>
                          {specificIndent?.hod_comment
                            ? specificIndent?.hod_comment
                            : "NA"}
                        </h6>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {specificIndent?.director_comment ? (
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>6. Director Comment</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>
                          {specificIndent?.director_comment
                            ? specificIndent?.director_comment
                            : "NA"}
                        </h6>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="mt-5">
                    <h5 className="my-5">Product List</h5>
                  </div>
                  <div>
                    <form>
                      <div className="scroll-table">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th scope="col">S.No</th>
                              <th scope="col">Product Name</th>
                              <th scope="col">Applied Quantity</th>
                              <th scope="col">Issued Quantity</th>
                              <th scope="col">Approved Quantity</th>
                              <th scope="col">Rejected Quantity</th>
                              <th scope="col">Hold Quantity</th>
                              <th scope="col">Already Acknowledged Quantity</th>
                              <th scope="col">New Issued Quantity</th>
                              <th scope="col">Acknowledge</th>
                            </tr>
                          </thead>
                          <tbody>
                            {specificIndent?.product_details?.map(
                              (product, index) => {
                                const validation = tempChanges[index];
                                return (
                                  <tr key={product.id}>
                                    <td>{index + 1}</td>
                                    <td className="textformat">
                                      {product?.product_name}
                                    </td>
                                    <td>
                                      {product?.quantity
                                        // ? product?.quantity
                                        // : "NA"
                                        }
                                    </td>
                                    <td>
                                      {product?.issued_quantity
                                        // ? product?.issued_quantity
                                        // : "NA"
                                        }
                                    </td>
                                    <td>
                                      {product?.approved_quantity
                                        // ? product?.approved_quantity
                                        // : "NA"
                                        }
                                    </td>
                                    <td>
                                      {product?.rejected_quantity
                                        // ? product?.rejected_quantity
                                        // : "NA"
                                        }
                                    </td>
                                    <td>
                                      {product?.hold_quantity
                                        // ? product?.hold_quantity
                                        // : "NA"
                                        }
                                    </td>
                                    <td>
                                      {product?.already_acknowledged_quantity
                                        // ? product?.already_acknowledged_quantity
                                        // : "NA"
                                        }
                                    </td>
                                    <td>
                                      {product?.issued_quantity -
                                        product?.already_acknowledged_quantity}
                                    </td>
                                    <td>
                                      <>
                                        {product?.issued_quantity &&
                                        product?.issued_quantity !==
                                          product?.already_acknowledged_quantity ? (
                                          <>
                                            <input
                                              key={index}
                                              type="text"
                                              className="fieldinputreport"
                                              placeholder="Enter Achnowledged Quantity"
                                              onChange={(e) =>
                                                handleChange(
                                                  e.target.value,
                                                  "product_details",
                                                  "already_acknowledged_quantity",
                                                  index,
                                                  product?.issued_quantity -
                                                    product?.already_acknowledged_quantity
                                                )
                                              }
                                            />
                                            <div>
                                              {errorMessages[index] ||
                                                (validation?.error && (
                                                  <small className="validationerror">
                                                    {errorMessages[index] ||
                                                      validation?.error}
                                                  </small>
                                                ))}
                                            </div>
                                          </>
                                        ) : (
                                          "-"
                                        )}
                                      </>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                      {buttonstatus && (
                        <div className="row my-5">
                          <div className="col-lg-5 mx-auto my-auto centertext">
                            <button
                              type="submit"
                              className="approvebutton"
                              onClick={(e) => handleSubmit(e)}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default IndentSpecificView;
